import { next } from "../utilities/selectorHelper";
import { CUSTOMER_TYPE_PARTICULAR, GTM_CARD_REMOVAL } from "../utilities/constants";

const clientSideValidation = require("../components/clientSideValidation");
const registerAddressFields = ["postalCode", "address1", "streetNumber", "floor", "doorSide", "city", "taxNumber"];
const registrationFormAddressData = {};
let profileFormCommonValues = {
    name: {
        value: ""
    },
    phone: {
        value: ""
    }
};

/**
 * @function
 * @description - Reset service error display
 * @param {Element} $serviceErrorContainer - Service error container element
 */
const serviceErrorReset = $serviceErrorContainer => {
    if ($serviceErrorContainer) {
        $serviceErrorContainer.classList.add("d-none");
        $serviceErrorContainer.querySelector(".ct-service-error-message").textContent = "";
    }
};

/**
 * clears non gengerated errors
 * @param {Object} form - form.
 */
const hideErrors = form => {
    const errorContainer = form.find(".invalid-feedback");
    errorContainer.children().addClass("d-none");
};

/**
 * @function
 * @desctiption - Appends the error message to the element
 * @param {Element} element - Error message element
 * @param {String} errorType - Error message
 */
const appendError = (element, errorType) => {
    const $errorMsgArea = $(".ct-register-corm--postalcode-error");
    const $this = $(element);
    const $errorMsgParticularInput = $("#registration-form-postalCode-particular");
    const $errorMsgCompanyInput = $("#registration-form-postalCode-company");

    if ($this.length) {
        const error = $this.attr(errorType);
        let msg = error ? error : errorType;

        $errorMsgArea.empty().html(msg).removeClass("d-none");
        $errorMsgParticularInput.empty().addClass("is-invalid");
        $errorMsgParticularInput.trigger("focus");
        $errorMsgCompanyInput.empty().addClass("is-invalid");
        $errorMsgCompanyInput.trigger("focus");
    }
};


/**
 * @function
 * @description - Display service error message
 * @param {Element} $serviceErrorContainer - Service error message container
 * @param {String} errorMessage - Error message
 */
const displayRegistrationFormServiceError = ($serviceErrorContainer, errorMessage) => {
    if (!$serviceErrorContainer) return;

    const $serviceErrorMsg = $serviceErrorContainer.querySelector(".ct-service-error-message");

    $serviceErrorContainer.classList.remove("d-none");
    $serviceErrorMsg.textContent = errorMessage;

    //GTM logic - Start
    document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
        detail: {
            "success": false,
            "messageContent": errorMessage
        }
    }));
    //GTM logic - End

};

/**
 * Toggle visibility of address form on register page
 * @param {String} postalCodeInput postal code selector
 */
const toggleAddressFormVisibility = postalCodeInput => {
    const $address = $(".js-address");
    const $postalCodeInput = $(postalCodeInput);
    const postalCodeValue = $postalCodeInput.val();
    const regExp = new RegExp($postalCodeInput.attr("pattern"));
    const isValid = regExp.test(postalCodeValue) && postalCodeValue.length == 8;

    $address.toggleClass("d-none", !isValid);
};

/**
 * Remove continente card event bind
 */
const removeCardClickEvent = () => {
    const loyaltyDeleteModalContent = document.querySelector(".ct-loyalty-card--remove-confirmation");
    const loyaltyUnsuccessfulRemovalContent = document.querySelector(".ct-loyalty-card--unsuccessful-removal");

    loyaltyDeleteModalContent.classList.remove("d-none");
    loyaltyUnsuccessfulRemovalContent.classList.add("d-none");

    //GTM logic - Start
    const msg = $(loyaltyDeleteModalContent).find(".modal-text-content").text();
    document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
        detail: {
            "success": true,
            "messageContent": msg
        }
    }));
    //GTM logic - End

    $("body").off("click").on("click", ".js-removeCard", function (e) {
        e.preventDefault();
        var url = $(this).attr("href");

        $.ajax({
            url: url,
            method: "POST",
            success: data => {
                if (data && data.error) {
                    loyaltyDeleteModalContent.classList.add("d-none");
                    loyaltyUnsuccessfulRemovalContent.classList.remove("d-none");

                    //GTM logic - Start
                    const errorMsg = $(loyaltyUnsuccessfulRemovalContent).find(".ct-loyalty-card--delete-modal-msg").text();
                    document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                        detail: {
                            "success": false,
                            "messageContent": errorMsg
                        }
                    }));
                    //GTM logic - End
                } else {
                    //GTM logic
                    document.dispatchEvent(new CustomEvent("dataLayer.loyaltyCardEvents", {
                        detail: {
                            "action": GTM_CARD_REMOVAL,
                        }
                    }));

                    location.href = data.redirectUrl;
                }
            }
        });
    });
};

/**
 * @function
 * @description - Toggles between company and personal fields and cleans hidden fields
 */
const handleAddressFields = () => {
    const $registrationFormParticularPostalCode = $("#registration-form-postalCode-particular");
    const $registrationFormCompanyPostalCode = $("#registration-form-postalCode-company");
    const $address = $(".js-address");
    const regExpParticular = new RegExp($registrationFormParticularPostalCode.attr("pattern"));
    const regExpCompany = new RegExp($registrationFormCompanyPostalCode.attr("pattern"));

    $address.toggleClass("d-none", !regExpParticular.test($registrationFormParticularPostalCode.val()));
    $address.toggleClass("d-none", !regExpCompany.test($registrationFormCompanyPostalCode.val()));

    $registrationFormParticularPostalCode.on("keyup", e => {
        const postalCode = $(e.target).val();

        if (regExpParticular.test(postalCode)) {
            $registrationFormParticularPostalCode.removeClass("is-invalid");
        }

        toggleAddressFormVisibility(e.target);
    });

    $registrationFormCompanyPostalCode.on("keyup", e => {
        const postalCode = $(e.target).val();

        if (regExpCompany.test(postalCode)) {
            $registrationFormCompanyPostalCode.removeClass("is-invalid");
        }

        toggleAddressFormVisibility(e.target);
    });
};

/**
 * @function
 * @description - Save registration address data entered for each contact type
 */
const archiveRegistrationAddressData = () => {
    const formData = $("form.particular-and-company-form").serializeArray();
    const selectedContactType = document.querySelector("input[name$=contactDataType]:checked").id;

    const nameField = document.querySelector(`input[id$=${selectedContactType.includes("company") ? "contactName" : "fname"}]`);

    profileFormCommonValues = {
        name: {
            value: nameField.value == "" ? profileFormCommonValues.name.value : nameField.value,
            isInvalid: nameField.classList.contains("is-invalid"),
            errorMsg: next(nameField, ".invalid-feedback")[0].textContent
        }
    };

    registrationFormAddressData[selectedContactType] = formData.filter(function (item) {
        const inputName = item.name.split("_").pop();
        const isInvalidInput = document.querySelector(`input[name="${item.name}"]`).classList.contains("is-invalid");

        item.isInvalid = isInvalidInput;

        return registerAddressFields.includes(inputName);
    });
};

/**
 * toggles disabled attribute to fields;
 * @param {Object} container - container with inputs.
 * @param {Boolean} state - true/false.
 */
const setDisabledState = (container, state) => container.find("input").prop("disabled", state);

/**
 * handles active fields;
 */
const handleActiveFields = () => {
    const isParticular = $("input[name$=contactDataType]:checked").val() === CUSTOMER_TYPE_PARTICULAR;
    setDisabledState($(".js-particular-data"), !isParticular);
    setDisabledState($(".js-company-data"), isParticular);
};

/**
 * Clear and reinitialize input field
 * @param {Element} field - Input field
 */
const clearFormInputField = field => {
    clientSideValidation.functions.toggleNoLabelAnimationClass(field);
    clientSideValidation.functions.reinitInput(field);
};

/**
 * @function
 * @description - Clear registration form address input fields
 */
const clearRegistrationAddressFields = () => {
    const $postalCode = document.querySelector("input[name$=postalCode]");
    const $address = document.querySelectorAll(".js-address");
    const taxNumber = document.querySelector("input[name$=taxNumber]");
    const $registrationFormCompanyPostalCode = $("#registration-form-postalCode-company");

    if ($registrationFormCompanyPostalCode.length > 0 && !$registrationFormCompanyPostalCode.val()) {
        $registrationFormCompanyPostalCode.removeClass("filled");
    }

    if ($address) {
        $address.forEach(item => {
            item.classList.add("d-none");
            item.querySelectorAll("input").forEach(elem => {
                clearFormInputField(elem);
            });
        });
    }

    if ($postalCode) {
        clearFormInputField($postalCode);

        if ($postalCode.value == "" && $postalCode.classList.contains("is-invalid")) {
            $postalCode.classList.remove("is-invalid");
        }
    }

    if (taxNumber) {
        clearFormInputField(taxNumber);

        if (taxNumber.value == "" && taxNumber.classList.contains("is-invalid")) {
            taxNumber.classList.remove("is-invalid");
        }
    }
};

/**
 * Update the profile form fields with proper values
 * @param {Element} field - Profile form field
 * @param {Object} data - Object containing the profile form values
 */
const updateFormField = (field, data) => {
    if (!data) {
        return;
    }
    field.value = data.value;
    clientSideValidation.functions.toggleNoLabelAnimationClass(field);
    field.classList.toggle("is-invalid", data.isInvalid);

    field.classList.toggle("filled", data.value !== "");

    if (data.errorMsg) {
        next(field, ".invalid-feedback")[0].textContent = data.errorMsg;
        //GTM logic - Start
        document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
            detail: {
                "success": false,
                "messageContent": data.errorMsg
            }
        }));
        //GTM logic - End
    }
};

/**
 * @function
 * @description - Fill in registration address fields with previous entered data
 */
const fillInAddressFields = () => {
    const isLoginPage = document.querySelector(".ct-login-page");
    const isShowProfilePage = document.querySelector(".personal-data-landing");
    const selectedContactType = document.querySelector("input[name$=contactDataType]:checked").id;
    const addressFormData = registrationFormAddressData[selectedContactType];
    const nameField = document.querySelector(`input[id$=${selectedContactType.includes("company") ? "contactName" : "fname"}]`);
    const phoneField = document.querySelector(`input[name$=${selectedContactType.includes("company") ? "company_phoneNumber" : "customer_phoneNumber"}]`);

    if (!isShowProfilePage) {
        updateFormField(nameField, profileFormCommonValues.name);
        updateFormField(phoneField, profileFormCommonValues.phone);
    }

    if (!addressFormData || !addressFormData?.length) {
        if (isLoginPage) { clearRegistrationAddressFields(); }
        return;
    }

    addressFormData.forEach(element => {
        const $element = document.querySelector(`input[name="${element.name}"]`);

        updateFormField($element, element);
    });
};

const setPersonalFields = () => {
    const isLoginPage = document.querySelector(".ct-login-page");
    const isShowProfilePage = document.querySelector(".personal-data-landing");
    const $companyDataForm = $(".js-company-data");

    if ($("input[name$=contactDataType]:checked").val() === CUSTOMER_TYPE_PARTICULAR) {
        $companyDataForm.addClass("d-none");
    } else {
        $(".js-particular-data").addClass("d-none");
        $companyDataForm.removeClass("d-none");

        if (!isLoginPage && !isShowProfilePage) {
            var customerTypeParticular = document.querySelector(".js-particular-title");
            var customerTypeCompany = document.querySelector(".js-company-title");
            if (customerTypeParticular && customerTypeCompany) {
                customerTypeParticular.closest(".pwc-form-radio").classList.remove("customer-type-active");
                customerTypeCompany.closest(".pwc-form-radio").classList.add("customer-type-active");
            }
        }
    }

    handleActiveFields();

    const $registrationContactType = $("input[name$=contactDataType]");

    if (!isShowProfilePage) {
        $registrationContactType.siblings(".pwc-form-check-label").on("mousedown", archiveRegistrationAddressData);
    }

    $registrationContactType.on("change", () => {
        fillInAddressFields();
        handleAddressFields();
        $(".js-particular-data").toggleClass("d-none");
        $(".js-company-data").toggleClass("d-none");
        
        if (!isLoginPage && !isShowProfilePage) {
            var customerTypeParticular = document.querySelector(".js-particular-title").closest(".pwc-form-radio");
            var customerTypeCompany = document.querySelector(".js-company-title").closest(".pwc-form-radio");

            if (customerTypeParticular.classList.contains("customer-type-active")) {
                customerTypeParticular.classList.remove("customer-type-active");
                customerTypeCompany.classList.add("customer-type-active");
            } else {
                customerTypeParticular.classList.add("customer-type-active");
                customerTypeCompany.classList.remove("customer-type-active");
            }
        }

        handleActiveFields();
    });
};

export {
    toggleAddressFormVisibility,
    removeCardClickEvent,
    setPersonalFields,
    handleAddressFields,
    serviceErrorReset,
    hideErrors,
    appendError,
    displayRegistrationFormServiceError
};
